import React, { useEffect } from "react";
// import Header from "../components/dashboard/header";
import tmdbApi from "../api/tmdbApi";
import Footer from "./dashboard/footer";
import Header from "./dashboard/header";
import { useNavigate, useParams } from "react-router-dom";

import headerRight from "../assets/images/inst-right-image.svg"


const Instructions = () => {
    const navigate = useNavigate();
    let { id } = useParams();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const navigateToQuiz = () => {
       
GetParticipatedTerms()
    }
const navigateToCpc = () => {
        navigate("/cpc/")
        
    }
// const GetParticipatedTerms = async () => {
//         try {
//             const res = await tmdbApi.getParticipatedTerms( id );
//              navigate("/quiz/" + id)
//             // setSuccessMsg(res?.result);
//             // setSuccessDisplay(true);
//         } catch (err) {
//             console.error(err);
//         }
//     };
const GetParticipatedTerms = async () => {
  try {
    const res = await tmdbApi.getParticipatedTerms(id);

    if (res?.statusCode === 200) {
      // ✅ if API success, then navigate
      navigate(`/quiz/${id}`);

      // If you want to show success messages later, uncomment these:
      // setSuccessMsg(res?.result);
      // setSuccessDisplay(true);
    } else {
      console.error("Failed to fetch participated terms:", res);
    }
  } catch (err) {
    console.error("Error in GetParticipatedTerms:", err);
  }
};

    return (
        <>
            <Header />
            <br />


            <div className="instructions-wapper">
                <div className="instructions-page instructions-modal">
                    <div className="instructions-header">
                        <h3 className="txt-48 text-light">INSTRUCTIONS FOR PARTICIPANTS <br></br> <span className="">Dermatopathology Diagnostic Quiz (Pre-CPC)</span></h3>
                        <img src={headerRight} alt="" />
                    </div>
                    <div className="instructions-points">
                        <p className="greeting">Dear Participant,</p>
                        <p>
                            You are invited to participate in this pre-CPC dermatopathology quiz hosted via the DADI website. This quiz is designed to assess and enhance your diagnostic reasoning based on clinical-pathological correlation. Please read the instructions carefully before submitting your responses.
                        </p>

                        <div className="section">
                            <h2>1. Case Format</h2>
                            <ul>
                                <li><span className="link-bullet me-2">›</span>A brief clinical summary</li>
                                <li><span className="link-bullet me-2">›</span>Representative histological images (static or virtual slides)</li>
                                <li><span className="link-bullet me-2">›</span>Additional notes (e.g., special stains or immunohistochemistry), if applicable</li>
                                <li><span className="link-bullet me-2">›</span>Your task is to review the case and submit your diagnostic impression(s).</li>
                            </ul>
                        </div>

                        <div className="section">
                            <h2>2. Submitting Your Diagnosis</h2>
                            <ul>
                                <li><span className="link-bullet me-2">›</span>You may provide up to four diagnostic possibilities, each with a corresponding confidence weight:</li>
                                <li><span className="link-bullet me-2">›</span>The total weight must equal exactly 100%.</li>
                                <li><span className="link-bullet me-2">›</span>You may enter a single diagnosis with 100% confidence, or distribute the weight across multiple differentials (e.g., 60/30/10)</li>
                                <li><span className="link-bullet me-2">›</span>You are not required to fill all four fields—leave unused fields blank</li>
                                <li><span className="link-bullet me-2">›</span>If you believe a case has two co-existing diagnoses, distribute the weightage accordingly (e.g., 50% + 50%).</li>

                            </ul>
                        </div>

                        <div className="section">
                            <h2>3. How to Enter Diagnoses</h2>
                            <ul>
                                <li><span className="link-bullet me-2">›</span>Begin typing part of a diagnosis (e.g., “dle”, “psor”, “follic”)</li>
                                <li><span className="link-bullet me-2">›</span>A drop-down list will display matching diagnoses from a predefined diagnostic database</li>
                                <li><span className="link-bullet me-2">›</span>Only selections from this list are permitted</li>
                                <li><span className="link-bullet me-2">›</span>Free-text entries are disabled to ensure standardisation</li>
                            </ul>
                        </div>

                        <div className="section">
                            <h2>4. Scoring and Marking</h2>
                            <ul>
                                <li><span className="link-bullet me-2">›</span>Each case has been assigned one or two reference diagnoses, based on expert panel consensus.</li>
                                <li><span className="link-bullet me-2">›</span>Each diagnosis carries a pre-assigned internal weight (e.g., 1.0 or 0.5) depending on its relevance</li>
                                <li><span className="link-bullet me-2">›</span>Your submitted diagnoses will be matched against these reference answers</li>
                                <li><span className="link-bullet me-2">›</span>You will be awarded credit proportional to how closely your response aligns with the reference weights</li>
                                <li><span className="link-bullet me-2">›</span>Cases with two reference diagnoses will have scores divided accordingly (e.g., 0.7 + 0.3 or 0.5 + 0.5)</li>
                                <li><span className="link-bullet me-2">›</span><strong>Note:</strong> No penalties are applied for incorrect answers in this quiz.</li>
                            </ul>
                        </div>

                        <div className="section">
                            <h2>5. Result Announcement</h2>
                            <p>
                                This quiz is part of the pre-CPC activity and is designed to stimulate reflection ahead of the live session. Final results and detailed feedback will be announced after the CPC concludes.
                            </p>
                        </div>

                        <div className="section">
                            <h2>6. Technical Notes</h2>
                            <ul>
                                <li>For optimal performance, use a laptop or desktop</li>
                                <li>Ensure a stable internet connection</li>
                                <li>For support, please contact: <em>[admin@dermpathacademy.in or +91 76748 23911]</em></li>
                            </ul>
                        </div>

                        <p className="closing">
                            We look forward to your participation and thoughtful interpretations.<br></br> Thank you for contributing to collaborative learning in dermatopathology.
                        </p>

                        <p className="signature">
                            Warm regards,<br />
                            <strong>Dr. Sasi Kiran Attili</strong><br />
                            On behalf of DADI – Dermatopathology and Diagnostics India<br />
                            <img src="https://dev.dermpathacademy.in/static/media/Dadi-logo.d4bbbf8e6e5218bb3024194748d15184.svg" width={240} alt="" />                </p>
                    </div>

                    <div className="d-flex justify-content-center align-items-center gap-3">
                           <div className="d-flex flex-wrap  justify-content-center gap-3 ms-0 ps-0 mt-0 mb-2 pb-4" onClick={() =>
                        navigateToQuiz()}>
                        <a className="register-link"><button className="btn-fill-icon"><span className="material-symbols-outlined btn-icon-fill-style">keyboard_arrow_right
                        </span>Agree & Continue</button></a>
                    </div>
                    <div className="d-flex flex-wrap justify-content-center gap-3 ms-0 ps-0 mt-0 mb-2 pb-4" onClick={() =>
                        navigateToCpc()}>
                           
                        <a className="register-link"><button className="btn-fill-icon"><span className="material-symbols-outlined btn-icon-fill-style">keyboard_arrow_right
                        </span>Cancel</button></a>
                        
                    </div>
                    </div>
                </div>

            </div>

            <Footer />
        </>
    );
};

export default Instructions;
